import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProfileService } from '@fairandsmart/angular';
import { Profile } from '@fairandsmart/types';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '@Env';
import { AuthService } from '@Services/auth.service';
import { RightConsentsService } from '@Services/right-consents.service';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { MatIconButton, MatButton } from '@angular/material/button';
import {
 MatMenuTrigger, MatMenu, MatMenuContent, MatMenuItem
} from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { FsAngularDirectivesModule } from '@fairandsmart/angular/directives';
import { AsyncPipe } from '@angular/common';
import { LogoutDialogComponent } from '../logout-dialog/logout-dialog.component';
import { LANGUAGES } from '../constants';

@Component({
    selector: 'fs-base-header',
    templateUrl: './base-header.component.html',
    styleUrls: ['./base-header.component.scss'],
    imports: [MatToolbar, MatToolbarRow, RouterLink, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuContent, MatMenuItem, MatButton, FsAngularDirectivesModule, AsyncPipe, TranslatePipe]
})
export class BaseHeaderComponent {
  auth = inject(AuthService);

  private dialog = inject(MatDialog);

  profileService = inject(ProfileService);

  translate = inject(TranslateService);

  rightConsentsService = inject(RightConsentsService);

  profile$: Observable<Profile>;

  readonly LANGUAGES = LANGUAGES;

  readonly CUSTOMIZATION = environment.customization;

  constructor() {
    this.profile$ = this.profileService.change;
  }

  logout() {
    this.dialog.open(LogoutDialogComponent).afterClosed().subscribe({
      next: (confirmation) => {
        if (confirmation) {
          this.auth.keycloak.logout({ redirectUri: window.location.origin });
          this.rightConsentsService.purge();
        }
      },
    });
  }
}
